module.exports = __webpack_public_path__ + "files/daa3f29073ee4a7946e2ff1371d11017.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-5.png
// module id = 1458
// module chunks = 60